import { ReportPage } from './ReportPage';

export function ResourceAllocation() {
  return <ReportPage reportName="Resource allocation" />;
}
